import React, { Component } from 'react'
import PropTypes from 'prop-types'
import appStore from '@loyal_images/app-store.svg'
import logo from '@loyal_images/brand/logo_bg_light.png'
import play from '@loyal_images/google-play.svg'
import IuppContactList from './IuppContactList'
import yn from 'yn'
import { FooterMenuLinkContent } from './FooterMenuLinks/index'

class FooterContent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      profileMenu: false,
      userMenu: false,
      categoryMenu: true,
      isHomeOrGuest: false,
      isHelpPage: false,
      isProfile: false,
      isCartPage: false,
      openNPS: false,
      showIuppMobileMenu: false
    }
  }

  render () {
    const isIupp = process.env.SKIN === 'iupp'
    const disclaimer = this.props.footerMenu.disclaimer

    return (
      <div className='box-footer-desktop'>
        <div className='container-footer footer-part-1 bg-brand-4 container-fluid py-4 d-none'>
          <div className='container py-1'>
            <div className='row'>
              <div className='address col-12 col-md-6 align-self-center'>
                <div className='row'>
                  <div className='col-12 col-md-3 pl-0 pr-2 txt-center'>
                    <img
                      src={logo}
                      className='address-logo'
                      alt={process.env.REACT_APP_TITLE || ''}
                    />
                  </div>
                  <div className='col-12 col-md-8 align-self-center mt-3 mt-md-0'>
                    <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                      Alameda Rio Negro, 585 - 13º andar
                    </p>
                    <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                      Alphaville - Barueri - SP - CEP 06454-000
                    </p>
                  </div>
                </div>
              </div>
              <div className='app col-12 col-md-6 d-none'>
                <div className='row'>
                  <div className='col-12 col-md-6 txt-right downloadit-app txt-circular-book txt-center txt-md-right mt-3 mt-md-0 align-self-center'>
                    <span className='txt-customsize-20x28 d-block'>
                      Baixe agora o app.
                    </span>
                  </div>
                  <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                    <img
                      className='img-h-100 img-w-auto google-play'
                      src={play}
                      alt='Baixe o aplicativo no Google play'
                    />
                  </div>
                  <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                    <img
                      className='img-h-100 img-w-auto app-store'
                      src={appStore}
                      alt='Baixe o aplicativo na App Store'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='container-footer container-fluid footer-part-2 bg-ui-1 d-xs-none d-sm-block'>
          <div className='container'>
            {yn(process.env.REACT_APP_FOOTERIUPP) ? (
              <IuppContactList
                profile={this.props.profile}
                meuBairro={this.props.meuBairro}
              />
            ) : (
              <div className='row'>
                <nav aria-label='Rodapé' className='links col-12 px-0 py-3'>
                  <ul className='row'>
                    <FooterMenuLinkContent footerMenu={this.props.footerMenu} />
                  </ul>
                </nav>
              </div>
            )}
            <div className='row mx-0 px-0'>
              <div className='legal col-12 col-xl-10 px-0 py-3'>
                {isIupp ? (
                  <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                    {process.env.REACT_APP_FOOTER_DISCLAIMER}
                  </p>
                ) : (
                  <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                    {disclaimer}
                  </p>
                )}
              </div>
              {!yn(process.env.REACT_APP_FOOTERIUPP) && (
                <div
                  className='address col-2 align-self-center txt-center logo-footer mx-auto'
                  role='img'
                  aria-label={process.env.REACT_APP_TITLE || ''}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

FooterContent.propTypes = {
  profile: PropTypes.object,
  footerMenu: PropTypes.object,
  meuBairro: PropTypes.bool
}

export default FooterContent



// WEBPACK FOOTER //
// ./src/App/Footer/FooterContent.js